import CollapsableManager from './CollapsableManager'

interface AccordionManagerOptions {
  selector?: string
  autoInit?: boolean
}

export default class AccordionManager extends CollapsableManager {
  constructor ({
    selector = '[data-ui-el="nfb-accordion-item-trigger"]',
    autoInit = true
  }: AccordionManagerOptions = {}) {
    super({
      selector,
      autoInit
    })
    this.selector = selector
  }

  init (): void {
    super.init()
  }

  destroy (): void {
    super.destroy()
  }
}
